// --- GCLID CAPTURE & STORAGE ---
// Inspired by Google's recommended pattern for offline conversion tracking:
// https://support.google.com/google-ads/answer/7012522

(function () {
  var GCLID_KEY = 'gclid';
  var GCLID_LIFETIME_DAYS = 90; // adjust if you want shorter

  function getQueryParam(name) {
    var regex = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
    var match = window.location.search.match(regex);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setGclid(gclid) {
    if (!gclid) return;

    try {
      var now = new Date().getTime();
      var expiryDate = now + GCLID_LIFETIME_DAYS * 24 * 60 * 60 * 1000;

      var record = {
        value: gclid,
        createdAt: now,
        expiryDate: expiryDate
      };

      window.localStorage.setItem(GCLID_KEY, JSON.stringify(record));
    } catch (e) {
      // localStorage might be disabled; fail silently
      console.warn('Unable to store gclid in localStorage', e);
    }
  }

  function init() {
    var gclid = getQueryParam(GCLID_KEY);
    if (gclid) {
      setGclid(gclid);
    }
  }

  // Run as soon as possible
  init();
})();